import type { GameProfile } from '../types';

const RED = '#BC4435';
const BLUE = '#2C4F8C';

export const ball48: GameProfile = {
  id: 'ball-48',
  label: '48 Balls (1–48)',
  ballIds: Array.from({ length: 48 }, (_, i) => i + 1),
  colorFor: (id) => (id % 2 === 1 ? RED : BLUE),
  textureStyle: 'standard',
  machineCount: 1,
  resultsPerDraw: 1,
};
